export const translations = {
  en: {
    // Header
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      pricing: 'Pricing',
      gallery: 'Gallery',
      contact: 'Contact',
    },
    // Hero
    hero: {
      slide1: 'Best Car Wash in <span>Montreal</span>   | Interior & Exterior Detailing Near You',
      slide2: 'Professional <span>Car</span> wash and detailing at multiple locations across Montreal or at your doorstep. Book your service online in seconds.',
      slide3: 'Best Car Wash in <span>Montreal</span>   | Interior & Exterior Detailing Near You',
    },
    // Intro
    intro: {
      title: 'InstaCarSpa is a professional car wash and auto detailing service in Montreal.',
      text1: 'We offer multiple convenient locations as well as mobile service at your doorstep.',
      text2: "Designed for both individuals and businesses, we provide flexible solutions to match your needs:",
      checks: [
        'Visit one of our detailing locations',
        'Book our mobile service at your home or workplace',
        'Schedule on-site service for your dealership, business, or vehicle fleet',
      ],
      text3: 'From one vehicle to an entire fleet, we deliver consistent, high-quality results you can rely on.',
      button: 'Book Now',
    },
    // Services
    services: {
      heading: 'Services',
      items: [
        {
          title: 'Car Wash & Detailing',
          description: 'Full hand wash - exterior and interior - eliminating all dirt, dust, & debris from surfaces.',
        },
        {
          title: 'Polishing & Waxing',
          description: 'Polishing & waxing to preserve the beauty and shine of your vehicle and safeguard against surface damages.',
        },
        {
          title: 'Wheel & Tire Deep Cleaning',
          description: 'A deep wash of both the rims and the tires keeping everything polished and shiny - eliminating all brake dust and grime.',
        },
        {
          title: 'Scratch Removal',
          description: 'Repairing minor scratches, swirls, and paint scuffs using safe non abrasive compounds.',
        },
        {
          title: 'Engine Cleaning',
          description: 'Engine wash and shampooing, degreasing of the engine compartment and metal components.',
        },
        {
          title: 'Auto Maintenance Services',
          description: 'Windshield washer fluid refill, windshield wiper replacement, tire pressure adjustment & more...',
        },
      ],
    },

    // About
    about: {
      heading: 'Who We Are',
      text1: 'InstaCarSpa is a professional car wash and auto detailing company based in Montreal, built around one simple idea: make premium car care as convenient as possible.',
      text2: 'What started as a mobile service has grown into a network of multiple detailing locations across the city, combined with a fully equipped mobile team that can come directly to your home or workplace.',
      text3: 'We service all types of vehicles, from daily drivers to SUVs and family cars, delivering consistent, high-quality results using professional equipment and eco-friendly products.',
      text4: 'Beyond individual customers, InstaCarSpa is also a trusted partner for car dealerships, businesses, and fleet operators, providing reliable, high-volume detailing services tailored to professional standards.',
      text5: 'With easy online booking, flexible service options, and a strong focus on quality, our goal is to deliver a seamless and dependable car care experience — every time.',
    
    },
    // Pricing
    pricing: {
      monthlyHeading: 'Interior AND Exterior Car Wash & Cleaning Packages - Monthly',
      monthlySubtitle: 'Attractive and affordable monthly packages to keep your car clean & shiny all month long. For Mobile service transportation fees will be added to the prices',
      oneTimeHeading: 'Interior & Exterior Packages - One Time Only',
      oneTimeSubtitle: 'Prices below are for one-time package service. For Mobile service transportation fees will be added to the prices',
      individualHeading: 'Individual Car Wash and Detailing Services',
      individualSubtitle: 'Prices below are per single service. For Mobile service transportation fees will be added to the prices',
      carTypes: {
        compact: '2 Seat Compact Cars',
        sedan: '5 Seat Sedans & SUVs',
        suv: '7 Seat SUVs, Pickups & Minivans',
      },
      contactUs: 'Contact Us',
      packages: {
        exteriorMonthly: {
          title: 'EXTERIOR - Monthly Package',
          description: 'Monthly EXTERIOR Package includes 4 exterior washes per month',
        },
        basicMonthly: {
          title: 'BASIC - Monthly Package',
          description: 'Monthly BASIC Package includes 4 basic exterior/interior washes per month',
        },
        superMonthly: {
          title: 'SUPER - Monthly Package',
          description: 'Monthly SUPER package includes 4 basic exterior/interior washes, 1 interior detailing, 1 wheel deep washes, 1 body spray wax per month',
        },
        basicOneTime: {
          title: 'BASIC - One-Time Package',
          description: 'BASIC One-Time Package includes 1 exterior wash & 1 interior wash',
        },
        superOneTime: {
          title: 'SUPER - One-Time Package',
          description: 'SUPER One-Time Package includes 1 exterior wash, 1 interior detailing, 1 wheel deep wash',
        },
        deluxeOneTime: {
          title: 'DELUXE - One-Time Package',
          description: 'DELUXE One-Time Package includes 1 exterior wash, 1 interior detailing, seats and floor shampooing, 1 wheel deep wash, 1 body spray Wax & 1 engine cleaning',
        },
        exteriorWash: {
          title: 'Car Wash Exterior',
          description: 'Pressure wash, hand wash, rinse & dry',
        },
        interiorWash: {
          title: 'Car Wash Interior',
          description: 'Vacuum, clean & wipe all interior',
        },
        interiorDetailing: {
          title: 'Interior Detailing',
          description: 'Shampooing floor mats, deep clean door jams, dash, vents & trims',
        },
        upholstery: {
          title: 'Upholstery Shampooing and Leather Treatment',
          description: 'Upholstery seats shampooing, clean, treat and condition leather surfaces (interior wash or detailing must be added with this)',
        },
        polishing: {
          title: 'Exterior Polishing & Scratch Removal',
          description: 'Smooth out surfaces, wet sanding, buffing, remove minor scratches & swirls',
        },
        ceramic: {
          title: 'Exterior Ceramic Coating',
          description: 'Apply a layer of nano ceramic shield to protect the paint from UV damage, oxidation & chemicals',
        },
        decontamination: {
          title: 'Exterior Decontamination and Waxing',
          description: 'Removal of insect residues, brake dust, iron deposits, and road tar, followed by paint protection with wax treatment',
        },
        headlight: {
          title: 'Headlight Restoration',
          description: 'Deep cleaning and restoration of headlights',
        },
        windshieldCeramic: {
          title: 'Ceramic Coating for Windshield, Windows & Mirrors',
          description: 'Application of a nano ceramic protective layer to guard against insect residues, repel water droplets, and prevent fogging on windows (additional interior treatment available)',
        },
      },
    },

    // Gallery
    gallery: {
      subtitle: 'Our Work',
      heading: 'Gallery',
      filters: {
        all: 'All',
        exterior: 'Exterior',
        interior: 'Interior',
      },
      labels: {
        tireCleaning: 'Tire Cleaning',
        ceramicCoating: 'Ceramic Coating',
        handWash: 'Hand Wash',
        deepCleaning: 'Deep Cleaning',
        detailWork: 'Detail Work',
        vacuumService: 'Vacuum Service',
        brushCleaning: 'Brush Cleaning',
        shammyFinish: 'Shammy Finish',
      },
      testimonialsTitle: 'What Our Customers Say',
      testimonials: [
        {
          text: "Great cleaning at a low price, they detail my car too and make it look brand new. Always consistent with their work, very friendly, and do their best to keep you happy. I have also referred this service to two of my friends in the building which are also satisfied",
          name: "Philip W.",
        },
        {
          text: "This is my second month with these guys and I must say it's been quite good and reliable, I have registered two cars an SUV and a smaller one and I get one wash per week for each done at my parking. They take the time to clean the car well and I'm very satisfied with the results",
          name: "Omar T.",
        },
        {
          text: "I'm very much enjoying this service, saves me the trips to the car wash center and keeps my car clean when I need it. I'm happy they now offer additional options like polish and waxing, will opt in for sure. Well priced and good value for the money, highly recommended.",
          name: "Adam A.",
        },
      ],
    },
    // Contact
    contact: {
      heading: 'Contact Us',
      companyName: 'Insta Car Spa',
      locationsLabel: 'Our Locations:',
      callUs: 'Call Us',
      emailUs: 'Email Us',
      formTitle: 'Send us a Message',
      namePlaceholder: 'Full Name',
      emailPlaceholder: 'Email Address',
      messagePlaceholder: 'Your Message',
      submitButton: 'Send Message',
      thankYou: 'Thank you for your message! We will get back to you soon.',
      errorMessage: 'Something went wrong. Please try again.',
      sending: 'Sending...',
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      messageRequired: 'Message is required',
    },
    // Footer
    footer: {
      copyright: '© 2024 Insta Car Spa.',
    },
    // Book Now Button
    bookNow: 'Book Now',
  },

  fr: {
    // Header
    nav: {
      home: 'Accueil',
      services: 'Services',
      about: 'À Propos',
      pricing: 'Tarifs',
      gallery: 'Galerie',
      contact: 'Contact',
    },
    // Hero
    hero: {
      slide1: 'Simple <span>pratique</span> Fiable & Efficace',
      slide2: 'Service de lavage <span>auto</span> et d\'esthétique dans votre stationnement',
      slide3: 'Simple <span>pratique</span> Fiable & Efficace',
    },
    // Intro
    intro: {
      title: 'VISITEZ-NOUS, NOUS VENONS À VOUS — OU NOUS VENONS À VOTRE ENTREPRISE',
      text1: 'InstaCarSpa a commencé comme un service de lavage auto mobile, et aujourd\u2019hui nous nous sommes étendus à plusieurs emplacements professionnels d\u2019esthétique à travers Montréal.',
      text2: 'Que vous cherchiez un lavage auto près de chez vous, un nettoyage intérieur ou une esthétique complète, vous pouvez :',
      checks: [
        'Visitez l\'un de nos emplacements pratiques',
        'R\u00e9servez notre \u00e9quipe mobile pour venir directement chez vous ou \u00e0 votre lieu de travail',
        'Planifiez un service sur place pour votre entreprise, concessionnaire ou flotte de v\u00e9hicules',
      ],
      text3: 'Des clients individuels aux concessionnaires et clients commerciaux, nous offrons le m\u00eame service de haute qualit\u00e9 et fiable \u00e0 chaque \u00e9chelle.',
      button: 'Forfaits',
    },
    // Services
    services: {
      heading: 'Services',
      items: [
        {
          title: 'Lavage & Esthétique Auto',
          description: 'Lavage complet à la main - extérieur et intérieur - éliminant toute la saleté, la poussière et les débris.',
        },
        {
          title: 'Polissage & Cirage',
          description: 'Polissage et cirage pour préserver la beauté et la brillance de votre véhicule et protéger contre les dommages de surface.',
        },
        {
          title: 'Nettoyage Profond Roues & Pneus',
          description: 'Un lavage en profondeur des jantes et des pneus gardant tout poli et brillant - éliminant toute la poussière de frein et la crasse.',
        },
        {
          title: 'Élimination des Rayures',
          description: 'Réparation des rayures mineures, tourbillons et éraflures de peinture à l\'aide de composés non abrasifs.',
        },
        {
          title: 'Nettoyage Moteur',
          description: 'Lavage et shampooing du moteur, dégraissage du compartiment moteur et des composants métalliques.',
        },
        {
          title: 'Services d\'Entretien Auto',
          description: 'Remplissage du liquide lave-glace, remplacement des essuie-glaces, ajustement de la pression des pneus et plus...',
        },
      ],
    },

    // About
    about: {
      heading: 'Qui Sommes-Nous',
      text1: 'Insta Car Spa est un service écologique de lavage et d\'esthétique automobile à Montréal, offrant un service rapide et pratique dans votre immeuble, à votre place de stationnement ou à l\'un de nos emplacements. Faites laver et détailler votre voiture dans le confort de votre maison ou immeuble avec Insta Car Spa.',
      text2: 'Notre service de lavage et d\'esthétique automobile couvre toutes les tailles de voitures, y compris les compactes, VUS, fourgonnettes et plus.',
      text3: 'Inscrivez-vous à nos forfaits mensuels et gardez votre voiture étincelante et brillante tout le mois.',
      text4: 'Notre objectif est d\'offrir à nos clients l\'expérience de lavage auto à la main la plus conviviale et pratique possible en utilisant les produits biodégradables et écologiques les plus modernes.',
    },
    // Pricing
    pricing: {
      monthlyHeading: 'Forfaits de Lavage Intérieur ET Extérieur - Mensuel',
      monthlySubtitle: 'Forfaits mensuels attrayants et abordables pour garder votre voiture propre et brillante tout le mois. Pour le service mobile, des frais de transport seront ajoutés aux prix',
      oneTimeHeading: 'Forfaits Intérieur & Extérieur - Une Seule Fois',
      oneTimeSubtitle: 'Les prix ci-dessous sont pour un service unique. Pour le service mobile, des frais de transport seront ajoutés aux prix',
      individualHeading: 'Services Individuels de Lavage et Esthétique',
      individualSubtitle: 'Les prix ci-dessous sont par service unique. Pour le service mobile, des frais de transport seront ajoutés aux prix',
      carTypes: {
        compact: 'Voitures Compactes 2 Places',
        sedan: 'Berlines & VUS 5 Places',
        suv: 'VUS, Camionnettes & Fourgonnettes 7 Places',
      },
      contactUs: 'Contactez-nous',
      packages: {
        exteriorMonthly: {
          title: 'EXTÉRIEUR - Forfait Mensuel',
          description: 'Le forfait mensuel EXTÉRIEUR comprend 4 lavages extérieurs par mois',
        },
        basicMonthly: {
          title: 'BASIQUE - Forfait Mensuel',
          description: 'Le forfait mensuel BASIQUE comprend 4 lavages basiques extérieur/intérieur par mois',
        },
        superMonthly: {
          title: 'SUPER - Forfait Mensuel',
          description: 'Le forfait mensuel SUPER comprend 4 lavages basiques extérieur/intérieur, 1 esthétique intérieure, 1 lavage profond des roues, 1 cire en spray par mois',
        },
        basicOneTime: {
          title: 'BASIQUE - Forfait Unique',
          description: 'Le forfait unique BASIQUE comprend 1 lavage extérieur et 1 lavage intérieur',
        },
        superOneTime: {
          title: 'SUPER - Forfait Unique',
          description: 'Le forfait unique SUPER comprend 1 lavage extérieur, 1 esthétique intérieure, 1 lavage profond des roues',
        },
        deluxeOneTime: {
          title: 'DELUXE - Forfait Unique',
          description: 'Le forfait unique DELUXE comprend 1 lavage extérieur, 1 esthétique intérieure, shampooing des sièges et du plancher, 1 lavage profond des roues, 1 cire en spray et 1 nettoyage moteur',
        },
        exteriorWash: {
          title: 'Lavage Extérieur',
          description: 'Lavage haute pression, lavage à la main, rinçage et séchage',
        },
        interiorWash: {
          title: 'Lavage Intérieur',
          description: 'Aspiration, nettoyage et essuyage de tout l\'intérieur',
        },
        interiorDetailing: {
          title: 'Esthétique Intérieure',
          description: 'Shampooing des tapis, nettoyage profond des joints de portes, tableau de bord, bouches d\'aération et garnitures',
        },
        upholstery: {
          title: 'Shampooing Sellerie et Traitement Cuir',
          description: 'Shampooing des sièges, nettoyage, traitement et conditionnement des surfaces en cuir (lavage ou esthétique intérieure doit être ajouté)',
        },
        polishing: {
          title: 'Polissage Extérieur & Élimination Rayures',
          description: 'Lissage des surfaces, ponçage humide, polissage, élimination des rayures mineures et tourbillons',
        },
        ceramic: {
          title: 'Revêtement Céramique Extérieur',
          description: 'Application d\'une couche de protection nano céramique pour protéger la peinture des dommages UV, de l\'oxydation et des produits chimiques',
        },
        decontamination: {
          title: 'Décontamination Extérieure et Cirage',
          description: 'Élimination des résidus d\'insectes, poussière de frein, dépôts de fer et goudron routier, suivie d\'une protection de peinture avec traitement à la cire',
        },
        headlight: {
          title: 'Restauration des Phares',
          description: 'Nettoyage en profondeur et restauration des phares',
        },
        windshieldCeramic: {
          title: 'Revêtement Céramique Pare-brise, Vitres & Rétroviseurs',
          description: 'Application d\'une couche protectrice nano céramique pour protéger contre les résidus d\'insectes, repousser les gouttes d\'eau et prévenir la buée (traitement intérieur supplémentaire disponible)',
        },
      },
    },

    // Gallery
    gallery: {
      subtitle: 'Notre Travail',
      heading: 'Galerie',
      filters: {
        all: 'Tout',
        exterior: 'Extérieur',
        interior: 'Intérieur',
      },
      labels: {
        tireCleaning: 'Nettoyage Pneus',
        ceramicCoating: 'Revêtement Céramique',
        handWash: 'Lavage Main',
        deepCleaning: 'Nettoyage Profond',
        detailWork: 'Travail Détail',
        vacuumService: 'Service Aspiration',
        brushCleaning: 'Nettoyage Brosse',
        shammyFinish: 'Finition Peau Chamois',
      },
      testimonialsTitle: 'Ce Que Disent Nos Clients',
      testimonials: [
        {
          text: "Excellent nettoyage à bas prix, ils détaillent aussi ma voiture et la font paraître comme neuve. Toujours constants dans leur travail, très sympathiques et font de leur mieux pour vous satisfaire. J'ai aussi recommandé ce service à deux de mes amis dans l'immeuble qui sont également satisfaits",
          name: "Philip W.",
        },
        {
          text: "C'est mon deuxième mois avec ces gars et je dois dire que c'est assez bon et fiable, j'ai enregistré deux voitures, un VUS et une plus petite, et j'ai un lavage par semaine pour chacune fait à mon stationnement. Ils prennent le temps de bien nettoyer la voiture et je suis très satisfait des résultats",
          name: "Omar T.",
        },
        {
          text: "J'apprécie beaucoup ce service, ça m'évite les déplacements au centre de lavage et garde ma voiture propre quand j'en ai besoin. Je suis content qu'ils offrent maintenant des options supplémentaires comme le polissage et le cirage, je vais certainement m'inscrire. Bon rapport qualité-prix, hautement recommandé.",
          name: "Adam A.",
        },
      ],
    },
    // Contact
    contact: {
      heading: 'Contactez-Nous',
      companyName: 'Insta Car Spa',
      locationsLabel: 'Nos Emplacements:',
      callUs: 'Appelez-Nous',
      emailUs: 'Écrivez-Nous',
      formTitle: 'Envoyez-nous un Message',
      namePlaceholder: 'Nom Complet',
      emailPlaceholder: 'Adresse Courriel',
      messagePlaceholder: 'Votre Message',
      submitButton: 'Envoyer le Message',
      thankYou: 'Merci pour votre message! Nous vous répondrons bientôt.',
      errorMessage: 'Une erreur est survenue. Veuillez réessayer.',
      sending: 'Envoi en cours...',
      nameRequired: 'Le nom est requis',
      emailRequired: 'Le courriel est requis',
      emailInvalid: 'Adresse courriel invalide',
      messageRequired: 'Le message est requis',
    },
    // Footer
    footer: {
      copyright: '© 2024 Insta Car Spa.',
    },
    // Book Now Button
    bookNow: 'Réserver',
  },
};
